var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06_Login ",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1609,
    transform: "translate(-439 -592)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Create an Account"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -201,
    width: 600,
    height: 689,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Create box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email*"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Example@gmail.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Button",
    x: -20,
    y: -20,
    width: 519,
    height: 55,
    rx: 10,
    fill: "#F4F5F6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Example@gmail.com_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6667 0H3.33333C2.4496 0.00108263 1.60237 0.360601 0.97748 0.999695C0.352588 1.63879 0.00105857 2.50528 0 3.40909L0 11.5909C0.00105857 12.4947 0.352588 13.3612 0.97748 14.0003C1.60237 14.6394 2.4496 14.9989 3.33333 15H12.6667C13.5504 14.9989 14.3976 14.6394 15.0225 14.0003C15.6474 13.3612 15.9989 12.4947 16 11.5909V3.40909C15.9989 2.50528 15.6474 1.63879 15.0225 0.999695C14.3976 0.360601 13.5504 0.00108263 12.6667 0ZM3.33333 1.36364H12.6667C13.0659 1.36444 13.4557 1.4874 13.786 1.71668C14.1163 1.94597 14.3719 2.2711 14.52 2.65023L9.41467 7.87227C9.03895 8.25499 8.53028 8.46986 8 8.46986C7.46972 8.46986 6.96105 8.25499 6.58533 7.87227L1.48 2.65023C1.6281 2.2711 1.88374 1.94597 2.21403 1.71668C2.54432 1.4874 2.93414 1.36444 3.33333 1.36364ZM12.6667 13.6364H3.33333C2.8029 13.6364 2.29419 13.4209 1.91912 13.0373C1.54405 12.6537 1.33333 12.1334 1.33333 11.5909V4.43182L5.64267 8.83636C6.26842 9.47472 7.11617 9.83321 8 9.83321C8.88383 9.83321 9.73158 9.47472 10.3573 8.83636L14.6667 4.43182V11.5909C14.6667 12.1334 14.456 12.6537 14.0809 13.0373C13.7058 13.4209 13.1971 13.6364 12.6667 13.6364Z",
    fill: "#706866"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -90,
    y: -226,
    width: 660,
    height: 749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858365 0 0 0 0 0.858365 0 0 0 0 0.858365 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1609,
    fill: "white",
    transform: "translate(-439 -592)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.27bbe9dde08352cc65d15baae3997ad4.svg";
export { ForwardRef as ReactComponent };